import { Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AppSubShell, Button, Card, CardTitle } from '@up2d8/ui';
import { NotificationPreferencesCard } from './notification-preferences-card';
import { PushCard } from './push-card';

/**
 * Meldingen per toestel — een subscherm, bereikt vanuit het profiel ("Ik").
 *
 * Dit is het enige waarvan een medewerker niet zelf kan nagaan of het werkt. "Push actief op
 * 2 toestellen" is hier hetzelfde antwoord als HR in het beheerscherm ziet.
 *
 * Onderaan, apart: je account verwijderen (DEL-1). De winkels eisen dat het in de app kan; het
 * staat onder de instellingen en niet in het profiel, zodat niemand het aantikt op zoek naar iets
 * anders.
 */
export function AppSettingsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AppSubShell title={t('appHome.settings')} onBack={() => void navigate({ to: '/app/profile' })}>
      <PushCard />
      {/* Meldingen per soort en de dagelijkse samenvatting (Stap 16). */}
      <NotificationPreferencesCard />
      <Card compact>
        <CardTitle>{t('accountDeletion.title')}</CardTitle>
        <p className="mt-element text-content text-text-secondary">
          {t('accountDeletion.app.settingsIntro')}
        </p>
        <Link to="/app/settings/account-verwijderen" className="mt-element inline-block">
          <Button variant="secondary">{t('accountDeletion.app.open')}</Button>
        </Link>
      </Card>
    </AppSubShell>
  );
}
